import { all, update, remove } from '../services/restApi'
import { message } from 'antd'
message.config({top: 110, duration: 4});
const _ = require('underscore')

const limit = 100;

export default {
	namespace : 'category',
	state : {
		categories: [],
		skip: 0,
		limit: limit,
		total_items: 0,
	},
	subscriptions : {
		setup({dispatch, history}) {

			history.listen(location => {
		        if (location.pathname === '/catalogs/expenses_type') {
		          	dispatch({type: 'firstLoad'})
		        }
		    })
		}
	},
	effects : {
		*query({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				// Model
				const data = {...payload, include: 'hotel'};

				const resp = yield call(all, 'Category', data)
				const categories = resp.results;

				yield put({ type: 'querySuccess', payload: {
					categories: categories,
					skip: payload.skip + limit,
					total_items: resp.count
				}})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')
			}

			yield put({type: 'app/hideLoadingTable'})
		},
		*update({payload}, {call, put}) {
			yield put({type: 'app/showButtonLoading'})

			try {

				let data = {...payload}
				data = _.omit(data, ['objectId', 'createdAt', 'updatedAt']);

				yield call(update, 'Category', payload.objectId, data);
				message.success('Se ha actualizado el registro exitosamente');

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')	
			}

			yield put({type: 'app/hideButtonLoading'})

		},
		*removeItem({payload}, {call, put}) {
			yield put({type: 'app/showLoadingTable'})

			try {
				yield call(remove, 'Category', payload.objectId);
				yield put({type: 'removeSuccess', payload: payload})

			} catch (e) {
				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')	
			}

			yield put({type: 'app/hideLoadingTable'})

		}
	},
	reducers : {
		queryFirst(state, action) {
			return {
				...state,
				...action.payload
			}
		},
		querySuccess(state, action) {
			return {
				...state,
				categories: state.categories.concat(action.payload.categories),
				skip: action.payload.skip,
				total_items: action.payload.total_items
			}
		},
		filterSuccess(state, action) {
			return {
				categories: action.payload.categories,
				skip: 0,
				total_items: action.payload.total_items
			}
		},
		createSuccess(state, action) {
			return {
				...state,
    			categories: [action.payload, ...state.categories]
			}
		},
		updateSuccess(state, action) {
			const obj = _.find(state.categories, {objectId: action.payload.objectId})
			_.extend(obj, action.payload)

			return {
				...state,
    			...action.payload
			}
		},
		removeSuccess(state, action) {

			let category = {};
			category = _.find(state.categories, {objectId: action.payload.objectId});
			state.categories = _.without(state.categories, _.find(state.categories, {objectId: category.objectId}));

			return {
				...state,
    			categories: state.categories
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/models/category.js